import React from 'react';
import { Page } from '../Page';
import { Droplets, Zap, Award } from 'lucide-react';
export function SupplementElectrolytes() {
  return <Page pageNumber={21} variant="light" data-id="element-3119" data-mp="2k8day7k6xfju">
      <div className="flex h-full gap-10" data-id="element-3120" data-mp="25ka12n311jpr">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3121" data-mp="25i5z4aoouus4">
          <img src="https://cdn.magicpatterns.com/uploads/3vpcu2q2uyntMMUQT4U38Z/pasted-image.png" alt="Thorne Daily Electrolytes" className="w-full max-w-[300px] object-contain" data-id="element-3122" data-mp="2ah8ut4is3onf" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3123" data-mp="1mm63mpwi593s">
          <div className="mb-6 pt-4" data-id="element-3124" data-mp="1mnha4xhc0uyl">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3125" data-mp="1rjfsa3c2hgqk">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3126" data-mp="3gx2qhr8chw2n">
              Daily Electrolytes
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3127" data-mp="2u1qxzxwzy2ev">
              Replace what GLP-1 side effects deplete
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3128" data-mp="2p2eadayawrb8" />
          </div>

          <div className="mb-6" data-id="element-3129" data-mp="32ukge47qphwy">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3130" data-mp="32tsr1b4qkgf4">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3131" data-mp="2b2v1gfxo1bxv">
              Dehydration and electrolyte imbalance are among the most common
              GLP-1 side effects. Nausea, vomiting, and reduced fluid intake all
              deplete electrolytes. Zero sugar and only 5 calories, critical
              when every calorie counts.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-3132" data-mp="2f72ton3c1a0u">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-3133" data-mp="3vhonceqe86bd">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-3134" data-mp="3qiv9gl772dao">480mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-3135" data-mp="2o6qx8ttkjr81">
                Sodium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-3136" data-mp="2t48wttlp4u3d">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-3137" data-mp="2x88bs7rbvkum">99mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-3138" data-mp="32603p1rz36yt">
                Potassium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-3139" data-mp="25hahx0d85u7k">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-3140" data-mp="29imejpuinfp9">40mg</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-3141" data-mp="2egxlnstffc3s">
                Magnesium
              </p>
            </div>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 text-center" data-id="element-3142" data-mp="2j85uonqugvgf">
              <p className="text-2xl font-serif text-[#1F1F1F]" data-id="element-3143" data-mp="1lqyv1szl36x0">0g</p>
              <p className="text-[10px] text-[#7A7A70] uppercase tracking-wider" data-id="element-3144" data-mp="1qqtmbxn9tyil">
                Sugar
              </p>
            </div>
          </div>

          <div className="mb-6" data-id="element-3145" data-mp="1j6sqpk725efx">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3146" data-mp="1e8he51pdopu0">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3147" data-mp="1994lg0btsoji">
              <li className="flex gap-2" data-id="element-3148" data-mp="19b8x54fyuruc">
                <Droplets className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3149" data-mp="156rdd59lwejk" />
                <span data-id="element-3150" data-mp="10980a8ona7t7">
                  Supports energy and reduces fatigue/brain fog from electrolyte
                  depletion
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3151" data-mp="vg6gbm9kzi2r">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3152" data-mp="qi4wgz4bzeq8" />
                <span data-id="element-3153" data-mp="lk3g4lyahtig">
                  Himalayan pink salt, naturally sweetened/flavored, 3 flavors
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3154" data-mp="hgx4eysera4l">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3155" data-mp="cj5bc1g11hyt" />
                <span data-id="element-3156" data-mp="cjx4l5m5j3lx">Stick packs for on-the-go, NSF Certified for Sport</span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3157" data-mp="2gmypdqxlxj39">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3158" data-mp="2glx4yvupbk8v">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3159" data-mp="22w3haguxn60q">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3160" data-mp="27t3lsnc4w0pq">
                <strong data-id="element-3161" data-mp="1sww3jskad9d3">1 stick pack</strong> in at least 12oz water daily
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3162" data-mp="1xw8q0c78wef5">
                30 stick packs per bag • 5 calories per serving
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3163" data-mp="1jyad7b8koq1r">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3164" data-mp="1ovahbglv3iq8" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3165" data-mp="3j9bhc4t5ebrw">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}